const AirCargo = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center">
        {/* <hr className="w-[50rem] mx-auto"/> */}
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]" />
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Air Cargo
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS commenced its air cargo operations in 1994, with its first
              Cessna 402 cargo plane, acquiring an AN-26 in 2001. Since then,
              continuously enhancing its Air Cargo division, TCS has been
              delivering a huge number of time-bound shipments and commodities
              across Pakistan, and a number of worldwide destinations. Our
              temperature-controlled warehouses and the fleet of primary and
              secondary distribution vehicles has helped a rapid growth of TCS
              air cargo division.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center sm:mt-[0rem] mt-[1rem]">
            <img
              src="/aviation/aviationaircargo.jpg"
              alt=""
              className="max-w-[100%] rounded-md"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default AirCargo;
